import { createLookup, isArrayEmpty, partition } from "../omnia"
import { getLabelForParameters, groupByParameters } from "./parameters"
import { Layer, SelectedLayerType, Selection } from "./types"

export function getVisibleLayers({ layers }: Selection, layerType: SelectedLayerType) {

    if (isArrayEmpty(layers)) return []
    if (!layerType?.typeId) return []

    const { typeId, dynamicScale } = layerType

    const ids = layers
        .filter(l => (l.typeId === typeId) && (Boolean(l.dynamicScale) === dynamicScale))
        .map(l => l.layerId)

    return ids

}

export function filterLayersByFields(layers: Layer[], fieldIds: number[]) {

    if (!fieldIds) {
        return layers
    }

    const set = new Set(fieldIds)

    return layers.filter(l => set.has(l.fieldId))

}


/**
 * Groups layers by shared TM parameters
 * Only "root" layers (i.e., with no "parentId") are considered for grouping
 * The associated "child" layers are always joined to their parent layer's group
 *
 * @param layers All layers
 * @returns Resulting layer groups
 */
export function groupLayers(layers: Layer[]) {

    const [parents, children] = partition(layers, l => !l.parentId)

    const childrenLookup = createLookup(children, c => c.parentId ?? 0)

    const groups = groupByParameters(parents)

    const result = groups.map(g => ({
        key: g.key,
        label: getLabelForParameters(g.parameters),
        parameters: g.parameters,
        layers: g.items.flatMap(l => {
            const c = childrenLookup[l.layerId]
            return c
                ? [l].concat(c)
                : [l]
        })
    }))

    return result

}
